import { isBackend } from "remult";

/**
 * Used to identify a method as a backend method
 * ## will not be available as a route from the client
 * for internal controller use only
 */
export function BackendOnly() {
  return function (
    _target: any,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      if (!isBackend())
        throw new Error(
          `Backend only method was invoked in client. at: ${propertyKey.toString()}`,
        );
      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
